import script from "./ChangeSegmentPageDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeSegmentPageDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeSegmentPageDialog.vue?vue&type=style&index=0&id=14ddf900&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ddf900"]])

export default __exports__